// extracted by mini-css-extract-plugin
module.exports = {"timesDesc":"dp-TQXXKRcA","item":"dp-BaKBy8XX"};